import {useMutation, useQuery} from '@tanstack/react-query';
import {
  IRenameTreeNodeResponse,
  IRenameTreeNodeRequest,
  ISavedSearchTreeViewResponse,
} from '../../api/types/savedSearch.type';
import {
  createTreeNode,
  getSavedSearchTreeView,
  renameTreeNode,
} from '../../api/endpoints/savedSearchApi';

export const useSavedSearchTreeView = (
  enabled: boolean = true,
  gcTime?: number
) => {
  return useQuery<ISavedSearchTreeViewResponse[], Error>({
    queryKey: ['savedSearchTreeView'],
    queryFn: getSavedSearchTreeView,
    enabled: enabled,
    ...(typeof gcTime === 'number' && {gcTime}),
  });
};

export const useRenameNode = (
  onSuccess?: () => void,
  onError?: (err: Error) => void
) => {
  return useMutation<IRenameTreeNodeResponse, Error, IRenameTreeNodeRequest>({
    mutationFn: renameTreeNode,
    onSuccess: () => {
      onSuccess?.();
    },
    onError: (error) => {
      onError?.(error);
    },
  });
};
export const useCreateNode = (
  onSuccess?: () => void,
  onError?: (err: Error) => void
) => {
  return useMutation<IRenameTreeNodeResponse, Error, IRenameTreeNodeRequest>({
    mutationFn: createTreeNode,
    onSuccess: () => {
      onSuccess?.();
    },
    onError: (error) => {
      onError?.(error);
    },
  });
};
